import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	dropdownTitle: {
		id: 'software-code-code-page.pages.connection-page.one-click-connect.dropdown-title',
		defaultMessage: 'Select Bitbucket workspace to connect to ',
		description:
			'Label for the select dropdown which lists the available Bitbucket workspaces to connect to',
	},
	connectButtonLabel: {
		id: 'software-code-code-page.pages.connection-page.one-click-connect.connect-button-label',
		defaultMessage: 'Connect',
		description: 'Label for the connect button',
	},
	cancelButtonLabel: {
		id: 'software-code-code-page.pages.connection-page.one-click-connect.cancel-button-label',
		defaultMessage: 'Cancel',
		description: 'Label for the cancel button',
	},
	continueButtonLabel: {
		id: 'software-code-code-page.pages.connection-page.one-click-connect.continue-button-label',
		defaultMessage: 'Continue',
		description: 'Label for the continue button',
	},
	successMessageLabel: {
		id: 'software-code-code-page.pages.connection-page.one-click-connect.success-message-label',
		defaultMessage: 'Successfully connected to ',
		description: 'Label for the success message',
	},
});
